import React, {useEffect} from "react";
import $ from "jquery";
import StringTools from "../../../class/tool/StringTools";
import "../../../css/tools/event/Events.css";

const Events = props => {
    const { event } = props;

	const addEvent = event => {
		let id = StringTools.makeID(30);
		$("#containerEvents").append("<p id='" + id + "' class='event " + event.type + "'>" + event.text + "</p>");

		setTimeout(() => { cleanEvent(id) }, 5000);
	}
    const cleanEvent = id => {
        $("#" +id).fadeOut(200, () => {
			$("#" +id).remove();
		});
    }

	useEffect(() => {
		if (event !== null)
			addEvent(event);
	}, [event]);

    return <div id={"containerEvents"} className={"containerEvents"} />;
}

export default Events;